import React from 'react';
import * as B from 'react-bootstrap';

export default class ChatCompanionNotAvailable extends React.Component {
  render() {
    // TODO: Add more troubleshooting details
    return (
      <div>
        <B.PageHeader style={{ textAlign: 'center' }}>No se encontró el servicio de impresión</B.PageHeader>
      </div>
    );
  }
}


// WEBPACK FOOTER //
// ./components/chat/companion/NotAvailable.js